export const DELETED = 0;
export const APPROVAL = 1;
export const APPROVED = 2;
export const ONGOING = 3;
export const COMPLETED = 4;
export const CANCELLED = 5;
export const REJECTED = 6;